import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DID, VerificationData } from 'voxloud-types/dist/models';
import { TranslateService } from '@ngx-translate/core';
import { VerificationDataService } from 'src/app/domains/dids/services';

@Component({
  selector: 'gdp-number-info-popup',
  templateUrl: './number-info-popup.component.html',
  styleUrls: ['./number-info-popup.component.scss']
})
export class NumberInfoPopupComponent implements OnInit {
  @Input() did: DID;
  public loading = false;
  public verificationData: VerificationData;
  public currentLang: string;
  public locale: string;
  constructor(
    private activeModal: NgbActiveModal,
    private translate: TranslateService,
    private verificationDataService: VerificationDataService
  ) { }

  ngOnInit() {
    this.currentLang = this.translate.currentLang;
    if (this.did.verification_data_id) {
      this.getVerificationData();
    }
    this.locale = `${this.translate.currentLang}-${this.translate.currentLang.toUpperCase()}`;
    this.translate.onLangChange.subscribe(l => {
      this.locale = `${l.lang}-${l.lang.toUpperCase()}`;
    });
  }

  getVerificationData() {
    this.loading = true;
    this.verificationDataService.getVerificationDataById(this.did.verification_data_id)
      .subscribe(
        (res: VerificationData) => {
          this.verificationData = res;
          this.loading = false;
        }, () => {
          this.verificationData = null;
          this.loading = false;
        }
      );
  }

  close() {
    this.activeModal.close();
  }
}
